import { CognitoUserPool } from "amazon-cognito-identity-js";

let _userPool = null;

export const createUserPool = () => {
  if (!_userPool) {
    _userPool = new CognitoUserPool({
      UserPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
      ClientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID
    });
  }
  return _userPool;
};
